// plant3d-mock-data.ts
// 工廠 3D 地圖 mock data

export const PLANT_3D_MOCK_DATA = {
  buildings: [
    {
      name: 'A棟',
      floors: [
        {
          floor: '1F',
          // 新增：背景圖片設定
          backgroundImage: {
            url: 'assets/images/floor-plans/1f-plan.jpg', // 您可以替換為實際的圖片路徑
            width: 25,  // 背景圖片寬度
            height: 25, // 背景圖片高度
            position: [5, 0.01, 0], // [x, y, z] 位置，y 設為 0.01 避免與地面重疊
            opacity: 0.7, // 透明度
            rotation: -Math.PI / 2 // 旋轉角度，讓圖片平躺在地面
          },
          objects: [
            // 大廳
            {
              type: 'wall',
              position: [5, 0.5, -3],
              size: [10, 1, 0.2],
              label: '大廳上牆',
            },
            {
              type: 'wall',
              position: [5, 0.5, 3],
              size: [10, 1, 0.2],
              label: '大廳下牆',
            },
            {
              type: 'wall',
              position: [0, 0.5, 0],
              size: [0.2, 1, 6],
              label: '大廳左牆',
            },
            {
              type: 'wall',
              position: [10, 0.5, 0],
              size: [0.2, 1, 6],
              label: '大廳右牆',
            },
            // 倉庫
            {
              type: 'wall',
              position: [-4, 0.5, 2],
              size: [6, 1, 0.2],
              label: '倉庫上牆',
            },
            {
              type: 'wall',
              position: [-4, 0.5, 6],
              size: [6, 1, 0.2],
              label: '倉庫下牆',
            },
            {
              type: 'wall',
              position: [-7, 0.5, 4],
              size: [0.2, 1, 4],
              label: '倉庫左牆',
            },
            {
              type: 'wall',
              position: [-1, 0.5, 4],
              size: [0.2, 1, 4],
              label: '倉庫右牆',
            },
            // 機房
            {
              type: 'wall',
              position: [12, 0.5, -2],
              size: [4, 1, 0.2],
              label: '機房上牆',
            },
            {
              type: 'wall',
              position: [12, 0.5, 2],
              size: [4, 1, 0.2],
              label: '機房下牆',
            },
            {
              type: 'wall',
              position: [10, 0.5, 0],
              size: [0.2, 1, 4],
              label: '機房左牆',
            },
            {
              type: 'wall',
              position: [14, 0.5, 0],
              size: [0.2, 1, 4],
              label: '機房右牆',
            },
            // 貨架
            {
              type: 'rack',
              position: [2, 0.5, -1],
              size: [2, 2, 0.5],
              label: '1F 貨架A',
            },
            {
              type: 'rack',
              position: [7, 0.5, 1],
              size: [2, 2, 0.5],
              label: '1F 貨架B',
            },
            // 機器
            {
              type: 'machine',
              position: [6, 0.5, 1],
              size: [1, 1, 1],
              label: '1F 機器A',
            },
            {
              type: 'machine',
              position: [-2, 0.5, 3],
              size: [1.2, 1, 1],
              label: '1F 機器B',
            },
            // 滅火器
            {
              type: 'extinguisher',
              position: [1, 0.5, 2],
              size: [0.3, 1, 0.3],
              color: 'red',
              label: '滅火器',
            },
            // 管線
            {
              type: 'pipe',
              position: [5, 1, 0],
              size: [6, 0.2, 0.2],
              color: 'gray',
              label: '水管',
            },
            // 照明
            {
              type: 'light',
              position: [3, 2, 0],
              size: [0.5, 0.2, 0.5],
              color: 'yellow',
              label: '大廳燈',
            },
            // 門
            {
              type: 'door',
              position: [5, 0.5, -3],
              size: [1, 2, 0.2],
              label: '大廳門',
            },
            {
              type: 'door',
              position: [-1, 0.5, 4],
              size: [0.8, 2, 0.2],
              label: '倉庫門',
            },
            {
              type: 'door',
              position: [14, 0.5, 0],
              size: [0.8, 2, 0.2],
              label: '機房門',
            },
            // 逃生路線
            {
              type: 'escape',
              path: [
                [5, 0.5, -3],
                [5, 0.5, 0],
                [10, 0.5, 0],
                [14, 0.5, 0],
              ],
              label: '1F 逃生路線',
            },
          ],
        },
        {
          floor: '2F',
          // 新增：背景圖片設定
          backgroundImage: {
            url: 'assets/images/floor-plans/2f-plan.jpg',
            width: 30,
            height: 30,
            position: [7, 0.01, 0],
            opacity: 0.6,
            rotation: -Math.PI / 2
          },
          objects: [
            // 研究室
            {
              type: 'wall',
              position: [7, 0.5, -4],
              size: [14, 1, 0.2],
              label: '研究室上牆',
            },
            {
              type: 'wall',
              position: [7, 0.5, 4],
              size: [14, 1, 0.2],
              label: '研究室下牆',
            },
            {
              type: 'wall',
              position: [0, 0.5, 0],
              size: [0.2, 1, 8],
              label: '研究室左牆',
            },
            {
              type: 'wall',
              position: [14, 0.5, 0],
              size: [0.2, 1, 8],
              label: '研究室右牆',
            },
            // 會議室
            {
              type: 'wall',
              position: [5, 0.5, 7],
              size: [10, 1, 0.2],
              label: '會議室上牆',
            },
            {
              type: 'wall',
              position: [5, 0.5, 13],
              size: [10, 1, 0.2],
              label: '會議室下牆',
            },
            {
              type: 'wall',
              position: [0, 0.5, 10],
              size: [0.2, 1, 6],
              label: '會議室左牆',
            },
            {
              type: 'wall',
              position: [10, 0.5, 10],
              size: [0.2, 1, 6],
              label: '會議室右牆',
            },
            // 小房間A
            {
              type: 'wall',
              position: [-4, 0.5, 7],
              size: [6, 1, 0.2],
              label: '小房間A上牆',
            },
            {
              type: 'wall',
              position: [-4, 0.5, 11],
              size: [6, 1, 0.2],
              label: '小房間A下牆',
            },
            {
              type: 'wall',
              position: [-7, 0.5, 9],
              size: [0.2, 1, 4],
              label: '小房間A左牆',
            },
            {
              type: 'wall',
              position: [-1, 0.5, 9],
              size: [0.2, 1, 4],
              label: '小房間A右牆',
            },
            // 小房間B
            {
              type: 'wall',
              position: [16, 0.5, 7],
              size: [4, 1, 0.2],
              label: '小房間B上牆',
            },
            {
              type: 'wall',
              position: [16, 0.5, 11],
              size: [4, 1, 0.2],
              label: '小房間B下牆',
            },
            {
              type: 'wall',
              position: [14, 0.5, 9],
              size: [0.2, 1, 4],
              label: '小房間B左牆',
            },
            {
              type: 'wall',
              position: [18, 0.5, 9],
              size: [0.2, 1, 4],
              label: '小房間B右牆',
            },
            // 貨架
            {
              type: 'rack',
              position: [3, 0.5, -2],
              size: [2, 2, 0.5],
              label: '2F 貨架A',
            },
            {
              type: 'rack',
              position: [12, 0.5, 2],
              size: [2, 2, 0.5],
              label: '2F 貨架B',
            },
            // 機器
            {
              type: 'machine',
              position: [8, 0.5, 6],
              size: [1.2, 1, 1],
              label: '2F 機器A',
            },
            {
              type: 'machine',
              position: [15, 0.5, 12],
              size: [1, 1, 1],
              label: '2F 機器B',
            },
            // 滅火器
            {
              type: 'extinguisher',
              position: [2, 0.5, 1],
              size: [0.3, 1, 0.3],
              color: 'red',
              label: '滅火器',
            },
            {
              type: 'extinguisher',
              position: [9, 0.5, 12],
              size: [0.3, 1, 0.3],
              color: 'red',
              label: '滅火器',
            },
            // 管線
            {
              type: 'pipe',
              position: [7, 1, 0],
              size: [8, 0.2, 0.2],
              color: 'gray',
              label: '水管',
            },
            {
              type: 'pipe',
              position: [7, 1, 4],
              size: [0.2, 0.2, 8],
              color: 'gray',
              label: '氣管',
            },
            // 照明設備
            {
              type: 'light',
              position: [4, 2, 0],
              size: [0.5, 0.2, 0.5],
              color: 'yellow',
              label: '研究室燈',
            },
            {
              type: 'light',
              position: [8, 2, 8],
              size: [0.5, 0.2, 0.5],
              color: 'yellow',
              label: '會議室燈',
            },
            // 門
            {
              type: 'door',
              position: [0, 0.5, 0],
              size: [0.8, 2, 0.2],
              label: '研究室門',
            },
            {
              type: 'door',
              position: [10, 0.5, 10],
              size: [0.8, 2, 0.2],
              label: '會議室門',
            },
            {
              type: 'door',
              position: [-1, 0.5, 9],
              size: [0.8, 2, 0.2],
              label: '小房間A門',
            },
            {
              type: 'door',
              position: [18, 0.5, 9],
              size: [0.8, 2, 0.2],
              label: '小房間B門',
            },
            // 逃生路線
            {
              type: 'escape',
              path: [
                [0, 0.5, 0],
                [7, 0.5, 0],
                [14, 0.5, 0],
                [18, 0.5, 9],
              ],
              label: '2F 逃生路線',
            },
          ],
        },
        {
          floor: '3F',
          // 新增：背景圖片設定
          backgroundImage: {
            url: 'assets/images/floor-plans/3f-plan.jpg',
            width: 28,
            height: 32,
            position: [6, 0.01, 1],
            opacity: 0.65,
            rotation: -Math.PI / 2
          },
          objects: [
            // 辦公室區域 group
            {
              type: 'area',
              name: '辦公室',
              label: '辦公室',
              position: [6, 0.5, 1], // 區域中心
              walls: [
                { position: [6, 0.5, -2], size: [12, 1, 0.2], label: '辦公室上牆' },
                { position: [6, 0.5, 4], size: [12, 1, 0.2], label: '辦公室下牆' },
                { position: [0, 0.5, 1], size: [0.2, 1, 6], label: '辦公室左牆' },
                { position: [12, 0.5, 1], size: [0.2, 1, 6], label: '辦公室右牆' },
              ],
              children: [
                {
                  type: 'door',
                  position: [0, 0.5, 1],
                  size: [0.8, 2, 0.2],
                  label: '辦公室門',
                  rotationY: Math.PI / 2,
                },
                {
                  type: 'rack',
                  position: [3, 0.5, -2],
                  size: [2, 2, 0.5],
                  label: '3F 貨架A',
                },
                {
                  type: 'machine',
                  position: [7, 0.5, 3],
                  size: [1, 1, 1],
                  label: '3F 機器A',
                },
                {
                  type: 'extinguisher',
                  position: [1, 0.5, -2],
                  size: [0.3, 1, 0.3],
                  color: 'red',
                  label: '滅火器',
                },
                {
                  type: 'light',
                  position: [5, 2, 2],
                  size: [0.5, 0.2, 0.5],
                  color: 'yellow',
                  label: '辦公室燈',
                },
              ],
            },
            // 主管室區域 group
            {
              type: 'area',
              name: '主管室',
              label: '主管室',
              position: [2, 0.5, 8], // 區域中心
              walls: [
                { position: [2, 0.5, 6], size: [4, 1, 0.2], label: '主管室上牆' },
                { position: [2, 0.5, 10], size: [4, 1, 0.2], label: '主管室下牆' },
                { position: [0, 0.5, 8], size: [0.2, 1, 4], label: '主管室左牆' },
                { position: [4, 0.5, 8], size: [0.2, 1, 4], label: '主管室右牆' },
              ],
              children: [
                // 門在右牆，需旋轉
                {
                  type: 'door',
                  position: [4, 0.5, 8],
                  size: [0.8, 2, 0.2],
                  label: '主管室門',
                  rotationY: Math.PI / 2,
                },
              ],
            },
            // 會議室區域 group
            {
              type: 'area',
              name: '3F會議室',
              label: '3F會議室',
              position: [8, 0.5, 8], // 區域中心
              walls: [
                {
                  position: [8, 0.5, 6],
                  size: [4, 1, 0.2],
                  label: '3F 會議室上牆',
                },
                {
                  position: [8, 0.5, 10],
                  size: [4, 1, 0.2],
                  label: '3F 會議室下牆',
                },
                {
                  position: [6, 0.5, 8],
                  size: [0.2, 1, 4],
                  label: '3F 會議室左牆',
                },
                {
                  position: [10, 0.5, 8],
                  size: [0.2, 1, 4],
                  label: '3F 會議室右牆',
                },
              ],
              children: [
                // 門在右牆，需旋轉
                {
                  type: 'door',
                  position: [10, 0.5, 8],
                  size: [0.8, 2, 0.2],
                  label: '3F 會議室門',
                  rotationY: Math.PI / 2,
                },
                {
                  type: 'machine',
                  position: [9, 0.5, 9],
                  size: [1.2, 1, 1],
                  label: '3F 機器B',
                },
              ],
            },

            // 逃生路線
            {
              type: 'escape',
              path: [
                [0, 0.5, 1],
                [6, 0.5, 1],
                [12, 0.5, 1],
                [10, 0.5, 8],
              ],
              label: '3F 逃生路線',
            },
          ],
        },
      ],
    },
    // 可再加更多建築物
  ],
};
